import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import {
  ListItem,
  ListItemText,
  List,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
  DialogContent,
  DialogContentText
} from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

export const AssociatedCampaignsModalDialog = props => {
  let { template, type } = props;

  const message =
    template.associatedCampaigns.length > 0
      ? `The ${type} '${template.name}' is associated with the following campaigns. You may continue to archive this template without any adverse affects. This template can be unarchived anytime.`
      : `This ${type} can be unarchived anytime.`;

  const onClick = uuid => {
    window.open(`campaigns/edit/${uuid}`, '_blank');
  };

  return (
    <>
      <Alert severity="warning">
        <AlertTitle>Do you wish to continue?</AlertTitle>
      </Alert>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
        <List dense={false}>
          {template.associatedCampaigns.map(campaign => (
            <ListItem key={campaign.uuid}>
              <ListItemText primary={campaign.name} />
              <ListItemSecondaryAction>
                <Tooltip title="Open in new window" arrow>
                  <IconButton edge="end" onClick={() => onClick(campaign.uuid)}>
                    <OpenInNewIcon />
                  </IconButton>
                </Tooltip>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </>
  );
};
